import ArrowSvg from 'Shared/svg/chevron.svg';

export const ArrowIcon: React.FunctionComponent = () => {
  return (
    <ArrowSvg className="h-20 min-h-20 fill-black-20 dark:fill-black-30" />
  );
};
